var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 17,
    viewBox: "0 0 28 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66699 8.33301C7.60613 8.33301 6.58871 7.91158 5.83857 7.16144C5.08842 6.41129 4.66699 5.39387 4.66699 4.33301C4.66699 3.27214 5.08842 2.25473 5.83857 1.50458C6.58871 0.754435 7.60613 0.333008 8.66699 0.333008C9.72786 0.333008 10.7453 0.754435 11.4954 1.50458C12.2456 2.25473 12.667 3.27214 12.667 4.33301C12.667 5.39387 12.2456 6.41129 11.4954 7.16144C10.7453 7.91158 9.72786 8.33301 8.66699 8.33301ZM19.3337 8.33301C18.2728 8.33301 17.2554 7.91158 16.5052 7.16144C15.7551 6.41129 15.3337 5.39387 15.3337 4.33301C15.3337 3.27214 15.7551 2.25473 16.5052 1.50458C17.2554 0.754435 18.2728 0.333008 19.3337 0.333008C20.3945 0.333008 21.4119 0.754435 22.1621 1.50458C22.9122 2.25473 23.3337 3.27214 23.3337 4.33301C23.3337 5.39387 22.9122 6.41129 22.1621 7.16144C21.4119 7.91158 20.3945 8.33301 19.3337 8.33301ZM8.66699 10.9997C10.1806 10.9979 11.6771 11.319 13.0566 11.9417C14.4362 12.5643 15.6671 13.4741 16.667 14.6103V16.333H0.666992V14.6103C1.66693 13.4741 2.89778 12.5643 4.27734 11.9417C5.6569 11.319 7.15343 10.9979 8.66699 10.9997ZM19.3337 16.333V13.6023L18.667 12.8463C18.1584 12.269 17.6007 11.7368 17.0003 11.2557C17.7663 11.0848 18.5488 10.9989 19.3337 10.9997C20.8472 10.9979 22.3438 11.319 23.7233 11.9417C25.1029 12.5643 26.3337 13.4741 27.3337 14.6103V16.333H19.3337Z",
    fill: "#ECEFF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessPeople);
export default __webpack_public_path__ + "static/media/business-people.806c691795ba9c9662ffb24b631a0917.svg";
export { ForwardRef as ReactComponent };